<template>
  <v-app>
    <v-app-bar app clipped color='blue-grey lighten-4'>
      <v-app-bar-nav-icon v-if='getAutenticado' @click.stop='drawer = !drawer' />
      <v-toolbar-title dark>
        <router-link tag='span' sytle='cursor : pointer' to='/'>JetBox Tracking Empresarial</router-link>
      </v-toolbar-title>
      <v-menu offset-y v-if='getAutenticado'>
        <template v-slot:activator='{ on }'>
          <v-btn color='blue-grey lighten-1' class='ml-9 mr-1 subtitle-2' dark v-on='on' small>
            <v-icon left>mdi-cookie</v-icon>Procesos
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for='(item, index) in procesosItems' :key='index'>
            <v-list-item-title dark>
              <router-link :to='item.to'>
                <v-icon>{{ item.icon }}</v-icon>
                {{ item.title }}
              </router-link>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y v-if='getAutenticado'>
        <template v-slot:activator='{ on }'>
          <v-btn color='blue-grey lighten-1' class='ml-9 mr-1 subtitle-2' dark v-on='on' small>
            <v-icon left>mdi-google-chrome</v-icon>Reportes
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for='(item, index) in reportesItems' :key='index'>
            <v-list-item-title dark>
              <router-link :to='item.to'>
                <v-icon>{{ item.icon }}</v-icon>
                {{ item.title }}
              </router-link>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-spacer></v-spacer>

      <v-btn href='/' text v-if='getAutenticado'>
        <span class='mr-2'>Logout</span>
        <v-icon @click='logout'>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>
    <v-footer app color='blue-grey' dark>
      <span>{{ footerTitle }}</span>
      <v-spacer />
      <span>&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>

    import { mapActions, mapGetters } from "vuex";

    export default {
        name: "App",
        components: {
        },
        data: () => ({
            //
            footerTitle:
                process.env.VUE_APP_TITLE +
                "    " +
                process.env.VUE_APP_BASE_URL_SERVER,
            procesosItems: [
                { title: "I M S", icon: "mdi-gavel", to: "/ims" }
            ],
            reportesItems: [
                { title: "Manifiesto", icon: "mdi-console", to: "/report/manifiesto" }
            ],

        }),
        computed: {
            ...mapGetters(["getAutenticado"])
        },
        methods: {
            ...mapActions(["setAutenticado"]),
            logout() {
                this.setAutenticado(false);
                this.$router.push("/");
            }
        }
    };
</script>
